import { render, staticRenderFns } from "./fabric.vue?vue&type=template&id=bcaf1d6e&scoped=true&"
import script from "./fabric.vue?vue&type=script&lang=js&"
export * from "./fabric.vue?vue&type=script&lang=js&"
import style0 from "./fabric.vue?vue&type=style&index=0&id=bcaf1d6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcaf1d6e",
  null
  
)

export default component.exports